import PropTypes from 'prop-types';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTranslation } from '../../common/LocalizationProvider';
import AerosDetailsMoreMenu from './AeroDetailsMoreMenu';
import { selectSession, selectGroupSelectedId } from '../../createSelectorUtils';

AerosDetailsPistes.propTypes = {
  runways: PropTypes.array,
  aero: PropTypes.object
};

export default function AerosDetailsPistes({ runways, aero }) {
  const navigate = useNavigate();
  const session = useSelector(selectSession);
  const groupId = useSelector(selectGroupSelectedId);
  const t = useTranslation();
  const TABLE_HEAD = session.administrator
    ? [
        { id: 'piste', label: t('fields_runway'), alignRight: false },
        { id: 'longueur', label: t('fields_length'), alignRight: false },
        { id: 'largeur', label: t('fields_width'), alignRight: false },
        { id: 'qfu', label: t('fields_qfu'), alignRight: false },
        { id: 'type', label: t('fields_type'), alignRight: false },
        { id: '' }
      ]
    : [
        { id: 'piste', label: t('fields_runway'), alignRight: false },
        { id: 'longueur', label: t('fields_length'), alignRight: false },
        { id: 'largeur', label: t('fields_width'), alignRight: false },
        { id: 'qfu', label: t('fields_qfu'), alignRight: false },
        { id: 'type', label: t('fields_type'), alignRight: false }
      ];
  return (
    <Stack marginTop={10}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={2}>
        <Typography variant="h6" gutterBottom>
          {runways.length > 1 ? t('details_runways') : t('details_runway')}
        </Typography>
        {(session.administrator || groupId === 0 < 1) && (
          <Button
            variant="contained"
            onClick={() => navigate('../add/runways', { state: { aeroId: aero.id } })}
            startIcon={<Icon icon={plusFill} />}
          >
            {t('new_runway')}
          </Button>
        )}
      </Stack>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {TABLE_HEAD.map((headCell) => (
                <TableCell key={headCell.id} align={headCell.alignRight ? 'right' : 'left'}>
                  {headCell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {runways.map((runway, index) => (
              <TableRow key={runway.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell align="left">
                  {t('fields_runway')} {index + 1}
                </TableCell>
                <TableCell align="left">{`${runway.longueur} m`}</TableCell>
                <TableCell align="left">{`${runway.largeur} m`}</TableCell>
                <TableCell align="left">
                  {runway.qfu} - {runway.qfu + 180 > 360 ? runway.qfu - 180 : runway.qfu + 180}
                </TableCell>
                <TableCell align="left">
                  {runway.type === 'GRAS' ? t('type_runway_unpaved') : t('type_runway_paved')}
                </TableCell>
                {session.administrator && (
                  <TableCell align="left">
                    <AerosDetailsMoreMenu id={runway.id} />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}
